import { Button, HStack } from '@chakra-ui/react'
import React from 'react'
import {Link} from "react-router-dom"

const Header = () => {
  return (
    <HStack p={"4"} shadow={"base"} bgColor={"blackAlpha.900"} justifyContent={"center"}>
        
        <Button variant={"outline"} color={"skyblue"}>
            <Link to="/">Home</Link>
        </Button>
        <Button variant={"outline"} color={"skyblue"}>
            <Link to="/exchanges">Market Places</Link>
        </Button>
        <Button variant={"outline"} color={"skyblue"}>
            <Link to="/coins">Coins</Link>
        </Button>

    </HStack>
  )
}

export default Header